<template>
    <div>
        <div class="adscroll-container">
            <AdScroll></AdScroll>
        </div>
        <div class="header">
            <div class="header-container">
                <h1>ZESA Tariffs</h1>
            </div>
        </div>

        <div class="container mt-3">
            <promo-banner
                storage-key="promoStrip_tariffs_v1"
                text="10 Winners, $50 Each! Celebrate Magetsi’s 10th Anniversary💃🏽."
                link-href="/giveaway-terms"
                link-text="Click for more"
            />
        </div>
        <div class="container mt-4">
            <div class="row">
                <div class="col-lg-9 mb-4">
                    <section>
                        <div class="mb-4">
                            <tariffs-table table_type="per_unit_tariffs" />
                        </div>
                        <div class="alert alert-primary text-center">
                            <h2>Never Run Out of Power!</h2>
                            <p>Get your ZESA tokens instantly and keep your electricity running. Download the updated ZESA tariffs below:</p>
                            <a href="/Updated%20Zesa%20Tariffs.pdf" class="btn btn-primary btn-sm" download>
                                Download Updated ZESA Tariffs
                            </a>
                        </div>
                        <div class="mb-4">
                            <tariffs-table table_type="zig_tariffs" />
                        </div>
                    </section>

                    <!-- Call-to-Action Section -->
                    <div class="text-center my-5">
                        <h2>Take Action</h2>
                        <div class="d-flex justify-content-center flex-wrap">
                            <router-link to="/zesa" class="btn btn-sm btn-primary mx-2 my-2">Buy ZESA Now</router-link>
                            <router-link to="/calculators/zesa-calculator" class="btn btn-sm btn-success mx-2 my-2">ZESA Calculator</router-link>
                        </div>
                    </div>
                    <section>
                        <h2 class ="text-8">No more surprises, know exactly how much you'll be paying for your electricity usage.</h2>
                        <p>
                            Zimbabwe Electricity Supply Authority (ZESA) plays a crucial role in providing electricity to households and businesses across Zimbabwe. As energy consumers, it's essential to understand the current ZESA tariffs to effectively manage electricity usage and costs in our households. Magetsi has made it a mandate to give you the details of the current ZESA tariffs, how they are structured, and what you as a consumer need to know to make informed decisions. In many parts of the world, including Zimbabwe, prepaid meters and buying electricity tokens have become a routine part of life. However, a common frustration that consumers often face is the uncertainty surrounding the exact units of electricity one will receive after purchasing your ZESA token. No doubt, this lack of clarity is a source of frustration among Zimbabwean families. With the rise of the knowledge for personal finance and budgeting knowing the exact ZESA units you will receive before purchase plays an important role in budgeting for your home.
                        </p>
                        <h3>Overview of ZESA Tariffs</h3>
                        <p>
                            ZESA tariffs are structured based on consumption bands and different categories of consumers. The tariffs are designed to cover the costs of generating, transmitting, and distributing electricity while ensuring sustainability and accessibility for consumers around Zimbabwean. Here are some of the things ZETDC considers in determining the current ZESA tariffs, REA. The Rural Electrification Levy is collected by ZETDC on behalf of REA, an organization in Zimbabwe that focuses on bringing power to the rural parts of Zimbabwe. The REA Levy is 6% and is included in the ZESA tariffs for your prepaid electricity token. To learn more about the organization and how it benefits Zimbabwe as a whole you can visit their website here. ZESA tariffs are updated monthly, to stay up-to-date with the current ZESA tariffs, be sure to visit   <router-link to="/">magetsi.co.zw</router-link> regularly and use the Magetsi calculator.
                        </p>
                        <div class="text-center my-4">
                            <p>Start a conversation with the Magetsi Chatbot to buy your ZESA token.</p>
                            <a href="https://wa.me/263785832033" class="btn btn-success btn-sm" target="_blank">
                                Chat on WhatsApp
                            </a>
                        </div>
                        <h3>Debunking ZESA Tariffs Myths</h3>
                        <p>
                            Speculations around ZESA Tariffs tend to cause panic and havoc among Zimbabweans. It’s time for Magetsi to debunk all the ZESA tariffs myths and boost your ZESA purchase confidence!
                        </p>
                        <h4>Is ZESA Cheaper On the First Day of The Month?</h4>
                        <p>
                            The answer to whether electricity is cheaper on the first day of each month is both yes and no. Every month, you are entitled to a discounted allocation of 400 units (kWh) of electricity, which has the lowest pricing based on the current ZESA tariffs. Essentially, your initial expenditure provides you with 400 kWh of electricity. Therefore, regardless of when you purchase electricity within the month, if it's your first purchase, you'll receive 400 kWh using the lowest current tariff rates which is in the consumption band of 0-5kWh.
                        </p>
                        <p>
                            This allocation of 400 kWh resets at the beginning of each month. For instance, if you've used up your 400 kWh allocation in March, starting from April 1st, you can once again purchase 400 kWh using the lowest rates for current ZESA tariffs. The timing of this purchase within April doesn't affect the price or allocation, as long as it's your first purchase of the month. The misconception that electricity is cheaper on the first day of each month stems from this reset of the 400 kWh allocation. In reality, the quota is reset each month, ensuring that you have access to discounted electricity throughout the month, not just on the first day. This system allows ZESA to manage the usage of in-households. The more units you use exceeding the allocation from ZESA, the higher the ZESA tariff rate.
                        </p>
                        <h4>Does My Residential Area Affect ZESA Tariffs?</h4>
                        <p>
                            Unlike the most popular opinion, your residential location has no effect on the current ZESA tariffs. Whether you stay in the high-density, low, or medium-density, ZESA tariffs remain the same. The price per unit is affected by your usage and whether or not it’s your first purchase of that particular month.
                        </p>
                        <h3>Tips for Managing Electricity Costs For Your Home</h3>
                        <ul>
                            <li>Monitor Usage: Regularly monitor electricity usage and identify areas where energy conservation measures can be implemented.</li>
                            <li>Energy Efficiency: Invest in energy-efficient appliances, lighting, and insulation to reduce overall energy consumption.</li>
                            <li>Renewable Energy: Consider investing in renewable energy systems such as solar panels to reduce reliance on grid electricity and take advantage of renewable energy tariffs.</li>
                            <li>Tariff Analysis: Regularly check the updated ZESA tariffs and act accordingly.</li>
                        </ul>
                        <h3>Frequently Asked Questions On Current ZESA Tariffs</h3>
                        <div>
                            <details>
                                <summary>How often do ZESA Tariffs Change?</summary>
                                <p>There is no official announcement from ZETDC on when they update the ZESA tariffs but trends show that ZESA Tariffs reset almost every month, ideally on the first of each month. Tariffs also update daily depending on the consumption band.</p>
                            </details>
                            <details>
                                <summary>Where can I find the Current ZESA Tariffs?</summary>
                                <p>Some reliable ZESA Tariffs include calculators.co.zw and Magetsi calculators.</p>
                            </details>
                            <details>
                                <summary>What are the latest ZESA tariffs?</summary>
                                <p>As in table above.</p>
                            </details>
                            <details>
                                <summary>How much is 400 units of ZESA?</summary>
                                <p>Each month you are entitled to a discounted 400kWh which costs about ZWG 1042.98 if it’s your first purchase of the month.</p>
                            </details>
                            <details>
                                <summary>How much electricity is there in 1 unit?</summary>
                                <p>1 unit of electricity = 1kWh.</p>
                            </details>
                        </div>
                    </section>
                </div>

                <!-- Sidebar -->
                <div class="col-lg-3">
                    <div class="sidebar">
                        <h2 class="text-center">Our Products</h2>
                        <div v-for="product in products" :key="product.name" class="mb-4">
                            <div class="card">
                                <img :src="product.image" :alt="product.name" class="card-img-top" />
                                <div class="card-body">
                                    <h5 class="card-title text-center">{{ product.name }}</h5>
                                    <p class="card-text text-center">{{ product.description }}</p>
                                    <router-link :to="product.link" class="btn btn-primary btn-sm btn-block">{{ product.linkText }}</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TariffsTable from "../../custom/tariffs-table.vue";
import AdScroll from "../../core/AdScroll.vue";
import AdCarousel from "../../core/AdCarousel.vue";
import PromoBanner from "../../core/PromoBanner.vue";


export default {
    name: "ZesaTariffs",
    components: {PromoBanner, AdCarousel, AdScroll, TariffsTable },
    metaInfo() {
        return {
            title: `Electricity Tariffs`,
        };
    },
    data() {
        return {
            products: [

                {
                    name: "Electricity",
                    image: "./image/zetdc-logo.png",
                    description: "Get the best electricity rates and ensure reliable power supply.",
                    link: "/zesa",
                    linkText: "Buy Now",
                },
                {
                    name: "Econet Airtime",
                    image: "./img/econet-wireless.png",
                    description: "Recharge your mobile with affordable airtime plans.",
                    link: "/airtime",
                    linkText: "Buy Now",
                },
                {
                    name: "NetOne Airtime",
                    image: "./img/netone.svg",
                    description: "Save on data and talk time with our bundle offers.",
                    link: "/bundles",
                    linkText: "Buy Now",
                },
                {
                    name: "TelOne",
                    image: "./img/telone.svg",
                    description: "Affordable internet and communication services for all.",
                    link: "/telone",
                    linkText: "Buy Now",
                },
                {
                    name: "Econet Bundles",
                    image: "./img/econet-wireless.png",
                    description: "Save on data and talk time with our bundle offers",
                    link: "/bundles",
                    linkText: "Buy Now",
                },
                {
                    name: "NetOne Bundles",
                    image: "./img/netone.svg",
                    description: "Save on data and talk time with our bundle offers",
                    link: "/bundles",
                    linkText: "Buy Now",
                },
            ],
        };
    },
};
</script>

<style scoped>
.card {
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center; /* Vertically aligns the content */
    padding: 10px;
}

.card-img-top {
    width: 80px;
    height: 80px;
    object-fit: contain;
}
/* Buttons */
.btn {
    border-radius: 2px;
    padding: 0.6rem 1.2rem;
}

/* Product Section */
.product img {
    object-fit: cover;
    height: 180px;
}
.sidebar {
    border-left: 1px solid #ddd;
    padding: 15px;
    border-radius: 8px;
}

.sidebar .card {
    border: none; /* Remove default border */

}
@media (max-width: 768px) {
    .mobile-ad {
        height: 155px;
    }

}
.adscroll-container {
    margin-top: 20px; /* Space above the AdScroll */
    margin-bottom: 20px; /* Space below the AdScroll */
}
.header {
    background: rgba(211, 211, 211, 0.4); /* Light grey with transparency */
    backdrop-filter: blur(8px); /* Adds blur effect */
    -webkit-backdrop-filter: blur(8px); /* Safari compatibility */
    border-bottom: 1px solid rgba(255, 255, 255, 0.3); /* Light border for separation */
    color: black; /* Black text for better visibility */
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: flex-start; /* Keep the content left-aligned */
    margin-bottom: 20px;
}

/* Container for consistent alignment with page content */
.header-container {
    max-width: 1200px; /* Same width as the main page content */
    margin: 0 auto; /* Center the container itself */
    padding-left: 20px; /* Align with the page content */
    display: flex;
    align-items: center;
}

</style>
